import { useContext } from 'react';
import { CardContent, Typography, TextField as MuiTextField } from '@material-ui/core';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { Autocomplete } from 'formik-material-ui-lab';
import { applicationContext } from 'helpers/services';


interface IProps {
    form: any
}

let GeneralInfo = ({ form }: IProps) => {
    let appService = useContext(applicationContext);


    return (
        <CardContent>
            <Typography variant="h4">General information</Typography>
            <Field
                label="Name"
                name="name"
                component={TextField}
                fullWidth
                margin="normal"
            />
            <Field
                name="programs"
                component={Autocomplete}
                multiple
                options={appService.referenceData.programs.map(x => x.key)}
                getOptionSelected={(option: string, value: string) => option === value}
                getOptionLabel={(option: string) => appService.referenceData.programs.getValueByKey(option) || ''}
                renderInput={(params: any) =>
                    <MuiTextField
                        {...params}
                        size="small"
                        margin="normal"
                        error={form.touched['programs'] && !!form.errors['programs']}
                        helperText={form.touched['programs'] && form.errors['programs']}
                        label="Programs"
                    />
                }
            />
            <Field
                label="Website"
                name="website"
                component={TextField}
                fullWidth
                margin="normal"
            />
            <Field
                name="brands"
                component={Autocomplete}
                multiple
                options={appService.referenceData.brands.map(x => x.key)}
                getOptionSelected={(option: string, value: string) => option === value}
                getOptionLabel={(option: string) => appService.referenceData.brands.getValueByKey(option) || ''}
                renderInput={(params: any) =>
                    <MuiTextField
                        {...params}
                        size="small"
                        margin="normal"
                        error={form.touched['brands'] && !!form.errors['brands']}
                        helperText={form.touched['brands'] && form.errors['brands']}
                        label="Brands"
                    />
                }
            />
            <Field
                name="markets"
                component={Autocomplete}
                multiple
                options={appService.referenceData.markets.map(x => x.key)}
                getOptionSelected={(option: string, value: string) => option === value}
                getOptionLabel={(option: string) => appService.referenceData.markets.getValueByKey(option) || ''}
                renderInput={(params: any) =>
                    <MuiTextField
                        {...params}
                        size="small"
                        margin="normal"
                        error={form.touched['markets'] && !!form.errors['markets']}
                        helperText={form.touched['markets'] && form.errors['markets']}
                        label="Markets"
                    />
                }
            />
        </CardContent>
    );
}

export default GeneralInfo;